export const TableVariant = Object.freeze({
  DETAIL: "detail",
  OVERVIEW: "overview"
});
